import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../../public/valutami.png'


const _hoisted_1 = { class: "error-msg" }
const _hoisted_2 = { class: "error-msg" }
const _hoisted_3 = { class: "error-msg" }
const _hoisted_4 = { class: "flex flex-col mt-10" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "flex flex-col mt-10" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "flex md:flex-row flex-col md:space-y-0 space-y-2 md:items-center -ml-0.5" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "mr-2 text-xl material-icons text-primary" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 material-icons" }, " people ", -1)
const _hoisted_14 = { class: "flex flex-col mt-10" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "flex flex-col mb-2 -mt-2 space-y-4 lg:flex-row lg:space-x-8 lg:space-y-0" }
const _hoisted_17 = { class: "flex items-center space-x-1" }
const _hoisted_18 = { class: "text-sm select-none text-muted" }
const _hoisted_19 = { class: "mr-2 text-sm" }
const _hoisted_20 = {
  style: {"width":"20px","height":"20px"},
  viewBox: "0 0 24 24"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13 14H11V8H13V14M15 1H9V3H15V1M5 13C5 9.13 8.13 6 12 6C15.29 6 18.05 8.28 18.79 11.34L19.39 10.74C19.71 10.42 20.1 10.21 20.5 10.1C20.18 9.11 19.67 8.19 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13C3 17.63 6.5 21.44 11 21.94V19.92C7.61 19.43 5 16.53 5 13M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "flex flex-col mt-3 space-y-2" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col mt-12 space-y-4"
}
const _hoisted_26 = { class: "text-darkText" }
const _hoisted_27 = { class: "flex flex-col items-start space-y-2 md:space-y-0 md:space-x-2 md:flex-row md:space-x-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "mlw-32 mt-1.5 overflow-hidden rounded-sm shadow-elevation" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-32",
    src: _imports_0
  })
], -1)
const _hoisted_29 = { class: "flex flex-col space-y-2" }
const _hoisted_30 = { class: "mt-8" }
const _hoisted_31 = { class: "flex items-center w-1/2 space-x-1" }
const _hoisted_32 = { class: "text-sm select-none text-muted" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons" }, " delete ", -1)
const _hoisted_34 = {
  key: 0,
  class: "-mt-4 mb-8 text-muted"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_CalendarInput = _resolveComponent("CalendarInput")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_TagInput = _resolveComponent("TagInput")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col mt-6 space-y-4 md:space-x-4 md:flex-row md:space-y-0", [
				_ctx.v$.modelValue.name.$errors.length > 0 ||
				_ctx.v$.modelValue.begin_timestamp.$errors.length > 0 ||
				_ctx.v$.modelValue.end_timestamp.$errors.length > 0
					? 'mb-1'
					: 'mb-6',
			]])
    }, [
      _createVNode(_component_TextInput, {
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitBlur())),
        class: "w-full md:mr-auto",
        modelValue: _ctx.modelValue.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitUpdate('name', $event)))
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("event_editor.name")) + " ", 1)
        ]),
        _: 2
      }, [
        (_ctx.v$.modelValue.name.$errors.length > 0)
          ? {
              name: "errors",
              fn: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.name.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("validation_errors.event." + error.$uid)), 1)
                  ]))
                }), 128))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"]),
      _createVNode(_component_CalendarInput, {
        class: "",
        modelValue: _ctx.modelValue.begin_timestamp,
        ref: "beginTimestampElement",
        onOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBeginTimestampOpen())),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDraft ? _ctx.emitUpdate('begin_timestamp', $event) : () => null))
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("event_editor.begin_timestamp")) + " ", 1)
        ]),
        _: 2
      }, [
        (_ctx.v$.modelValue.begin_timestamp.$errors.length > 0)
          ? {
              name: "errors",
              fn: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.begin_timestamp.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("validation_errors.event." + error.$uid)), 1)
                  ]))
                }), 128))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"]),
      _createVNode(_component_CalendarInput, {
        class: "",
        modelValue: _ctx.modelValue.end_timestamp,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitUpdate('end_timestamp', $event)))
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("event_editor.end_timestamp")) + " ", 1)
        ]),
        _: 2
      }, [
        (_ctx.v$.modelValue.end_timestamp.$errors.length > 0)
          ? {
              name: "errors",
              fn: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.end_timestamp.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("validation_errors.event." + error.$uid)), 1)
                  ]))
                }), 128))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"])
    ], 2),
    _createVNode(_component_TextEditor, {
      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitBlur())),
      modelValue: _ctx.modelValue.instructions,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitUpdate('instructions', $event)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("event_editor.instructions")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("event_editor.flow_rules")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_RadioGroup, {
          class: "-ml-1.5",
          modelValue: _ctx.modelValue.exercises_shown_at_a_time,
          options: _ctx.exercisesShownAtOnceOptions,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitUpdate('exercises_shown_at_a_time', $event)))
        }, null, 8, ["modelValue", "options"])
      ]),
      _withDirectives(_createVNode(_component_Toggle, {
        labelOnLeft: true,
        style: {"max-width":"95%"},
        modelValue: _ctx.modelValue.allow_going_back,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.emitUpdate('allow_going_back', $event)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("event_editor.allow_going_back_label")), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]), [
        [_vShow, _ctx.modelValue.exercises_shown_at_a_time == 1]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("event_editor.access_rules")), 1),
      _createVNode(_component_RadioGroup, {
        class: "-ml-1.5 mb-2",
        modelValue: _ctx.modelValue.access_rule,
        options: _ctx.accessRulesOptions,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.onAccessRuleChange($event)))
      }, null, 8, ["modelValue", "options"]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.modelValue.access_rule === _ctx.EventAccessRule.ALLOW_ACCESS ? "public" : "lock"), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.modelValue.access_rule === _ctx.EventAccessRule.ALLOW_ACCESS
								? _ctx.$t("event_editor.allow_access_description")
								: _ctx.$t("event_editor.deny_access_description")), 1)
        ]),
        _createVNode(_component_Btn, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAccessRuleDialog = true)),
          class: _normalizeClass([
						_ctx.modelValue.access_rule === _ctx.EventAccessRule.DENY_ACCESS
							? 'visible'
							: 'hidden md:block invisible',
						'md:ml-8',
					]),
          size: 'sm',
          variant: 'secondary'
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("event_editor.choose_allowed")), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createElementVNode("p", {
          class: _normalizeClass([
						_ctx.modelValue.access_rule === _ctx.EventAccessRule.DENY_ACCESS
							? 'visible'
							: 'hidden md:block invisible',
						'md:ml-4',
					])
        }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.modelValue.access_rule_exceptions?.length ?? 0), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("event_editor.allowed_students")), 1)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t("event_editor.time_limit_rules")), 1),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_Toggle, {
          labelOnLeft: true,
          modelValue: _ctx.timeLimitRuleProxy,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timeLimitRuleProxy) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("event_editor.time_limit_label")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col space-y-2 md:items-center md:flex-row md:space-y-0", {
						'opacity-0 hidden lg:flex':
							_ctx.modelValue.time_limit_rule !== _ctx.EventTimeLimitRule.TIME_LIMIT,
					}])
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_NumberInput, {
              disabled: _ctx.modelValue.time_limit_rule !== _ctx.EventTimeLimitRule.TIME_LIMIT,
              class: "w-full",
              small: false,
              modelValue: _ctx.timeLimitProxy,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.timeLimitProxy) = $event)),
              leftIcon: 'timer'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("misc.time_limit")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"]),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("misc.minutes")), 1)
          ]),
          _createVNode(_component_Btn, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showTimeLimitDialog = true)),
            class: "md:ml-10",
            size: 'sm',
            variant: 'secondary'
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_19, [
                (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("event_editor.manage_time_limit_exceptions")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", {
            class: _normalizeClass([
							_ctx.modelValue.time_limit_rule === _ctx.EventTimeLimitRule.TIME_LIMIT
								? 'visible'
								: 'invisible',
							'md:ml-4',
						])
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.modelValue.time_limit_exceptions?.length ?? 0), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("event_editor.time_limit_exceptions")), 1)
          ], 2)
        ], 2)
      ]),
      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.modelValue.time_limit_rule === _ctx.EventTimeLimitRule.TIME_LIMIT
						? _ctx.$t("event_editor.time_limit_description")
						: _ctx.$t("event_editor.no_time_limit_description")), 1)
    ]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showAccessRuleDialog,
      onYes: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showAccessRuleDialog = false)),
      confirmOnly: true,
      fullWidth: true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("event_editor.choose_allowed")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("event_editor.manage_allowed_description")), 1),
          _createVNode(_component_TagInput, {
            modelValue: _ctx.allowedAccessAsTags,
            allowAutocomplete: false,
            onAddTag: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onAddAllowedAccess($event))),
            onRemoveTag: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onRemoveAllowedAccess($event))),
            placeholder: _ctx.$t('event_editor.student_email')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        (!_ctx.isDemoMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t("event_editor.import_from_valutami")), 1),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("event_editor.manage_allowed_import_from_valutami_1")) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("event_editor.manage_allowed_import_from_valutami_2")), 1),
                    _createTextVNode(". " + _toDisplayString(_ctx.$t("event_editor.manage_allowed_import_from_valutami_3")), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      type: "file",
                      onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args)))
                    }, null, 32)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["showDialog"]),
    _createVNode(_component_Dialog, {
      onYes: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showTimeLimitDialog = false)),
      showDialog: _ctx.showTimeLimitDialog,
      confirmOnly: true,
      fullWidth: true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("event_editor.exceptions_to_time_limit")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.time_limit_exceptions, (exception, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: _ctx.modelValue.id + '-time-limit-exc-' + index,
              class: "flex my-6 lg:w-1/2"
            }, [
              _createVNode(_component_TextInput, {
                class: "w-full mr-2 md:mr-4",
                modelValue: exception[0],
                "onUpdate:modelValue": ($event: any) => ((exception[0]) = $event)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("event_editor.student_email")), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_NumberInput, {
                  class: "w-full",
                  small: false,
                  modelValue: parseFloat(exception[1]) / 60,
                  "onUpdate:modelValue": ($event: any) => (exception[1] = parseFloat($event || 0) * 60),
                  leftIcon: 'timer'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.mediaQueryMdMatches ? _ctx.$t("misc.time_limit") : _ctx.$t("misc.limit")), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("misc.minutes")), 1)
              ]),
              _createVNode(_component_Btn, {
                class: "transition-opacity duration-100 opacity-50 md:ml-4 hover:opacity-100",
                outline: true,
                variant: 'icon',
                tooltip: _ctx.$t('event_editor.delete_exception'),
                onClick: ($event: any) => (_ctx.onRemoveTimeLimitException(index))
              }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 2
              }, 1032, ["tooltip", "onClick"])
            ]))
          }), 128)),
          ((_ctx.modelValue.time_limit_exceptions ?? []).length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.$t("event_editor.no_time_limit_exception")), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_Btn, {
            class: "mb-4",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onAddTimeLimitException()))
          }, {
            default: _withCtx(() => [
              _hoisted_35,
              _createTextVNode(_toDisplayString(_ctx.$t("event_editor.add_exception")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["showDialog"]),
    _createVNode(_component_Dialog, {
      onYes: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showDialog = false)),
      showDialog: _ctx.showDialog,
      confirmOnly: true
    }, {
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("event_editor.cannot_change_timestamp")), 1)
      ]),
      _: 1
    }, 8, ["showDialog"])
  ]))
}